import { InputHTMLAttributes } from "react";
import './Input.scss'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	icon?: string;
	variant?: string;
}

export function Input({variant, icon, ...rest}: InputProps) {
	return(
		<div className="align-items-center d-flex">
			{icon && <span className="material-icons input-icon">{icon}</span>}
			<input className={`input ${variant ? variant : ''}`} {...rest} />
		</div>
	)
}
